module.exports = __webpack_public_path__ + "static/media/settings-icon.afe9826b.svg";